import { useDelegate } from 'contexts/delegate.context';

import Tooltip from 'components/common/tooltip/tooltip';
import QuestionIcon from 'components/icons/QuestionIcon';

import {
  StyledHeading,
  StyledItemText,
  StyledList,
  StyledListItem,
  StyledSection,
  StyledValue
} from '../single-page.style';

const switchStatus = (poolStatus) => {
  let className = 'status-';
  let status = '';

  switch (poolStatus) {
    case 'OPEN':
      status = 'OPEN';
      className = `${className}-success`;
      break;
    case 'CLOSED':
      status = 'CLOSED';
      className = `${className}-closed`;
  }
  return { className, status };
};

const LeftSection = ({ name }) => {
  const { poolStatus, poolLimit, estimatedReturn } = useDelegate();
  const { className, status } = switchStatus(poolStatus);

  return (
    <StyledSection p="37px">
      <StyledHeading>{name}</StyledHeading>
      <StyledList>
        <StyledListItem>
          <StyledItemText>Pool Status</StyledItemText>
          <StyledValue className={className}>{status}</StyledValue>
        </StyledListItem>
        <StyledListItem>
          <StyledItemText>
            Pool Limit
            <Tooltip
              isMultiline
              type="info"
              message="Indicates the maximum <br /> amount of OPN a pool can hold"
            >
              <QuestionIcon />
            </Tooltip>
          </StyledItemText>
          <StyledValue>{poolLimit}</StyledValue>
        </StyledListItem>
        <StyledListItem>
          <StyledItemText>Estimated Return</StyledItemText>
          <StyledValue>{estimatedReturn}</StyledValue>
        </StyledListItem>
      </StyledList>
    </StyledSection>
  );
};

export default LeftSection;
